module.exports = __webpack_public_path__ + "static/media/ksalog.c1ce90dc.png";